import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarHoverHR(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);

    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="HR"?"":"HR")} title="HR" className={props.activeMenu == "HR" ? "sidenav-collapsed-active pointer px-0 sidenavbar-text":"pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:hr:view")?false:true}>
                <span className="mx-2 sidenavbar-text">HR
                    <i className={showMenu=="HR"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "HR" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/hr/employee")} title="Employees"
                className={props.activeSubMenu == "EmployeeList" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:employee:view")?false:true}>
                    Employees
                </a>
            </ul>
            <ul className={showMenu == "HR" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/hr/attendanceleave")} title="Attendance & Leave"
                className={props.activeSubMenu == "AttendanceLeave" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:attendance:view")?false:true}>
                    Attendance &amp; Leave
                </a>
            </ul>
            <ul className={showMenu == "HR" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/hr/payroll")} title="Payroll"
                className={props.activeSubMenu == "PayrollManagement" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:payroll:view")?false:true}>
                    Payroll
                </a>
            </ul>
            <ul className={showMenu == "HR" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/hr/asset")} title="Asset Management"
                className={props.activeSubMenu == "AssetManagement" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:asset:view")?false:true}>
                    Asset Management
                </a>
            </ul>
        </>
    );
}

export default SideNavBarHoverHR;
